export enum EtapasCierre {
    RealizarCierre,
    CargarDatos,
    Comparativas,
    ParteDiario,
    Finalizar
}